import React, { useEffect } from "react";
import MerchantPanel from "./panel/merchantPanel";
import { useParams } from "react-router-dom";
import { useAdmin } from "../../context/adminContext";

const Merchants = () => {
  // ger route param id
  const { id } = useParams();
  const { setActiveMerchantId } = useAdmin();
  useEffect(() => {
    setActiveMerchantId(id);
  }, [id]);
  return (
    <div className="vatMerchantListontainer mt-3">
      <MerchantPanel />
    </div>
  );
};

export default Merchants;
